<script setup lang="ts">
import type { ActiveFilterChip } from '~/utils/filter/chips'

const openFilter = defineModel('openFilter', { default: false })

const { searchKeyword, totalHits, sortFilter, typeFilter, authorFilter, legalAreaFilter, showOnlyFavorites } = useLiteratureFilters()

const { loggedIn } = useUserSession()

const chips = computed<ActiveFilterChip[]>(() => [
  ...typeFilter.value.map(option => ({
    key: `type:${option.value}`,
    label: option.label,
    remove: () => {
      typeFilter.value = typeFilter.value.filter(o => o.value !== option.value)
    },
  })),
  ...legalAreaFilter.value.map(option => ({
    key: `area:${option.value}`,
    label: option.label,
    remove: () => {
      legalAreaFilter.value = legalAreaFilter.value.filter(o => o.value !== option.value)
    },
  })),
  ...authorFilter.value.map(option => ({
    key: `author:${option.value}`,
    label: option.label,
    remove: () => {
      authorFilter.value = authorFilter.value.filter(o => o.value !== option.value)
    },
  })),
  ...(loggedIn.value && showOnlyFavorites.value
    ? [{ key: 'favorites', label: 'Favoritter', remove: () => { showOnlyFavorites.value = false } }]
    : []),
])
</script>

<template>
  <FilterListHeader
    v-model:search="searchKeyword"
    v-model:open-filter="openFilter"
    breakpoint="xl"
    :count="`${totalHits} treff`"
    search-id="literature-search-compact"
    search-label="Filtrer på tittel, forfatter eller rettsområde"
    search-placeholder="Finn faglitteratur"
    :chips="chips"
  >
    <template #actions>
      <FilterFavoritesChip v-model="showOnlyFavorites" breakpoint="xl" />
      <FilterSortSelect id="sort-literature" v-model="sortFilter" :options="LITERATURE_SORTING_OPTIONS" />
    </template>
    <LiteratureMobileFilters v-model:open-filter="openFilter" />
  </FilterListHeader>
</template>